

<div style="position: relative;">
<div id="map" style="height: 500px;"></div>
    <div class="search-container">
        <i class="ti ti-search"></i>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange($event)"
          (keydown.enter)="$event.preventDefault()"
          placeholder="Search location"
          class="search-box"
        />
        <!--  -->
        <!-- @if(isLandingPage){
          <i class="ti ti-info-circle text-wrap fs-16" placement="bottom" ngbTooltip="Sila masukan alamat permohonan kiblat dan alihkan pin merah ke lokasi yang tepat. Jika alamat tidak dijumpai, masukan 'landmark' yang berhampiran dan alihkan pin merah ke lokasi yang tepat"></i>
        } -->
        @if(loader){
          <div class="spinner-border text-dark" role="status" style="width: 15px; height: 15px;"></div>
        }

        <ul *ngIf="searchResults.length" class="dropdown">
          <li *ngFor="let result of searchResults" (click)="selectLocation(result)">
           {{result.properties.name}} {{ result.properties.street}}, {{result.properties.district}}
          </li>
        </ul>
      </div>
      <p style="position: absolute; bottom: 50px; right: 10px; background-color: #ff0000; padding: 5px; border-radius: 20px;">
        <img width="30px" src="assets/images/broom.png" alt="" (click)="clearBearingLine()">
      </p>

      <!-- <div class="map-controls">
        <button (click)="switchBaseLayer('Street')">Street</button>
        <button (click)="switchBaseLayer('Satellite')">Satellite</button>
        <button (click)="switchBaseLayer('Hybrid')">Hybrid</button>
      </div> -->

      <div ngbDropdown placement="top-end" [display]="'dynamic'" style="position: absolute; bottom: 10px; right: 10px;">
        <button type="button" class="btn drop-arrow-none"
                id="dropdownBasic2"
                ngbDropdownToggle
                style="background-color: rgb(197, 197, 197); font-size: 34px; padding: 3px; border-radius: 50px;">
          <i class="ti ti-stack-front"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic2" style="margin-left: -129px;">
          <button ngbDropdownItem (click)="switchBaseLayer('Street')">Street</button>
          <button ngbDropdownItem (click)="switchBaseLayer('Satellite')">Satellite</button>
          <button ngbDropdownItem (click)="switchBaseLayer('Hybrid')">Hybrid</button>
        </div>
      </div>


</div>
<div class="bg-dark text-white text-center">
    Bearing: {{bearing}}
</div>
@if(!isLandingPage){
  <p class="mx-2" style="text-align: justify;">Sila masukan alamat permohonan kiblat dan alihkan pin merah ke lokasi yang tepat. Jika alamat tidak dijumpai, masukan 'landmark' yang berhampiran dan alihkan pin merah ke lokasi yang tepat</p>
}
